import { apiClient, ApiResponse } from './client'

export interface LoginRequest {
  username: string
  password: string
}

export interface UserDto {
  id: string
  accountId: string
  roles: string[]
  name: string
  email?: string
  phone: string
  profileImageKey?: string
  status: 'ACTIVE' | 'PENDING_APPROVAL' | 'DEACTIVATED'
  deviceId?: string
  deviceToken?: string
  devicePlatform?: 'IOS' | 'ANDROID' | 'WEB'
  locale?: 'HE' | 'AR' | 'RU' | 'EN'
  timezone?: string
  lastLoginAt?: string
  cognitoUserId?: string
  rating?: number
}

export interface AuthResponse {
  accessToken: string
  refreshToken: string
  tokenType: string
  expiresIn: number
  user: UserDto
}

export const authService = {
  login: async (credentials: LoginRequest): Promise<AuthResponse> => {
    const response = await apiClient.post<ApiResponse<AuthResponse>>(
      '/api/v1/auth/loginUser',
      credentials
    )
    return response.data.data
  },

  logout: async (token: string, allDevices = false): Promise<void> => {
    await apiClient.post('/api/v1/auth/logout', null, {
      params: { allDevices },
      headers: { Authorization: `Bearer ${token}` }
    })
  },

  refreshToken: async (refreshToken: string): Promise<AuthResponse> => {
    const response = await apiClient.post<ApiResponse<AuthResponse>>(
      '/api/v1/auth/refresh',
      { refreshToken }
    )
    return response.data.data
  },
}

